/* DHC v1037 — sort visible size pills without altering Shopify option values */
(function(){
  'use strict';
  function score(v){
    v=String(v||'').trim().toUpperCase();
    var nums=v.match(/\d+(?:\.\d+)?/g);
    if(nums&&nums.length){
      var n=parseFloat(nums[0]);
      if(/M\b/.test(v) && !/T/.test(v)) return n/12;
      return n;
    }
    var order={XXS:0,XS:1,S:2,SMALL:2,M:3,MEDIUM:3,L:4,LARGE:4,XL:5,XXL:6,'2XL':6,XXXL:7,'3XL':7,'4XL':8,'5XL':9};
    return Object.prototype.hasOwnProperty.call(order,v)?order[v]:999;
  }
  function boot(root){
    (root||document).querySelectorAll('[data-dhc-size-group] .dhc-pdp__option-pills').forEach(function(wrap){
      var pills=Array.prototype.slice.call(wrap.querySelectorAll('[data-dhc-size-pill]'));
      pills.sort(function(a,b){
        return score(a.dataset.dhcSizeValue)-score(b.dataset.dhcSizeValue);
      }).forEach(function(p){wrap.appendChild(p);});
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){boot(document)},{once:true});
  else boot(document);
  document.addEventListener('shopify:section:load',function(e){boot(e.target);});
})();
